import { trimObject } from "@perxis-auto/shared";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import { createAppSlice } from "../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { name } from "../config/name.js";
const initialState = {
  isVisible: true,
  values: {},
  options: {
    sort: ["-position"]
  },
  history: []
};
const slice = createAppSlice({
  name,
  initialState,
  reducers: {
    setValues: (state, action) => {
      state.values = trimObject({
        ...state.values,
        ...action.payload
      });
    },
    resetValues: (state) => {
      state.values = {};
    },
    setOptions: (state, action) => {
      state.options = action.payload;
    },
    setSort: (state, action) => {
      state.options = {
        ...state.options,
        sort: action.payload
      };
    },
    setHistory: (state, action) => {
      state.history = action.payload;
    },
    resetHistory: (state) => {
      state.history = [];
    },
    setIsVisible: (state, action) => {
      state.isVisible = action.payload;
    }
  }
});
const { reducer, actions, reducerPath } = slice;
export {
  actions,
  reducer,
  reducerPath,
  slice
};
